var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","position":"relative","overflow":"hidden"},attrs:{"id":"markupsApp"}},[_c('markups-popup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }